<template>
  <div id="app" style="position: relative" v-if="modelShow">
    <!-- <app-header></app-header> -->
    <router-view :style="{ minHeight: Height + 'px' }" />
    <!-- <router-view /> -->
    <!-- <app-footer v-show="!(path === '/client' || path === '/phone' || path === '/teamwork' || path === '/myGame/gameDetail')"></app-footer> -->
    <!-- <app-footer v-show="!(path == '/' || path == '/home/index' || path == '/aboutUs' || path == '/permit' || path == '/softwareLis' || path == '/privacy' || path == '/contactUs')"></app-footer> -->
    <app-footer
      v-show="!(path == '/updateLog' || path == '/engineDownload')"
    ></app-footer>
  </div>
</template>
<script>
import AppHeader from "./components/headerCom.vue";
import AppFooter from "./components/footer.vue";
import { getGameLink } from "@/req/homes";
export default {
  data() {
    return {
      path: "",
      paths: "",
      Height: 0,
      modelShow: false,
    };
  },
  created() {
    if (this.isMobile()) {
      this.modelShow = true;
      // location.href = "http://wap.996box.com";
      location.href = "http://m.996m2.com";
    } else {
      this.modelShow = true;
    }
    this.getDownList();
  },
  mounted() {
    // this.isIE();
    // 对比当前path
    this.path = this.$route.path;
    // 动态获取当前高度-header+footer的宽度让footer始终居底
    this.Height = document.documentElement.clientHeight;
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight;
      // setRem()
    };
    // 1rem大小为 屏幕宽度1/10
    // 动态监听屏幕宽度变化，实时设置rem大小
    // function setRem() {
    //   let w = window.innerWidth // 获取屏幕宽度
    //   // 最大宽度限制
    //   if (w > 1920) {
    //     w = 1920
    //   }
    //   // 设置rem大小
    //   document.documentElement.style.fontSize = w / 10 + 'px'
    // }
    // setRem()
  },

  components: {
    AppHeader,
    AppFooter,
  },
  methods: {
    isIE() {
      // if (window.navigator.userAgent.indexOf("MSIE") >= 1) {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        window.location.href = "http://land.996box.com/downloadPage/ie.html";
        // alert(1)
        return true;
      } else {
        return false;
      }
    },
    async getDownList() {
      const res = await getGameLink();
      this.$store.state.home.downList = res;
    },
    isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: "Microsoft YaHei";
  overflow-y: hidden;
  min-width: 1227px;
  max-width: 1920px;
  margin: 0 auto;
  //   position: absolute;
  //   left: 0;
  //   right: 0;
  //   top: 0;
  //   bottom: 0;
  //  :style="{minHeight: height+'px'}"
  // console.log(document.documentElement.clientHeight)
  overflow-x: hidden; /*隐藏水平滚动条*/
  overflow-y: hidden; /*隐藏水平滚动条*/
}
// ::-webkit-scrollbar {
//   display: none; /* Chrome Safari */
// }
#cnzz_stat_icon_1279833995, #cnzz_stat_icon_1281161116, #cnzz_stat_icon_1281161115 {
  position: absolute;
  opacity: 0;
}

::-webkit-scrollbar {
  display: none; /* Chrome Safari */
  -ms-overflow-style: none;
  scrollbar-width: none;
}
html {
  /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
  -ms-overflow-style: none;
  /*火狐下隐藏滚动条*/
  overflow: -moz-scrollbars-none;
  /* 官网置灰 */
  // filter: grayscale(1) !important;
  // -webkit-filter:grayscale(1) !important;
}
// body {
//     filter: grayscale(1);
// }
.news_detail .content p img {
  width: 100%;
}
</style>
